module.exports = __webpack_public_path__ + "static/media/whatsapp.a693f520.svg";